import { connect } from 'react-redux';

import NavBar from './NavBar';
import { setSignOutIsVisible } from '../Inputs/SignOut/actions';
import { eraseCustomer } from '../AddClient/ClientInfo/actions';
import { eraseCustomerContact } from '../AddClient/Contact/actions';
import { setToggleView } from '../common/settings/actions';

const mapStateToProps = state => ({
    companyName: state.clientInfoUI.companyName,
    country: state.clientInfoUI.country,
    city: state.clientInfoUI.city,
    Zip: state.clientInfoUI.Zip,
    street: state.clientInfoUI.street,
    street2: state.clientInfoUI.street2,
    selectedState: state.clientInfoUI.selectedState,
    firstName: state.contactUI.firstName,
    lastName: state.contactUI.lastName,
    email: state.contactUI.email,
    position: state.contactUI.position,
    selectedFinancing: state.settings.selectedFinancing,
    installYear: state.tax.installYear,
    authToken: state.auth.authToken,
    clientId: state.addClientUI.clientId,
    setSignOutIsVisible,
    isSignOutVisible: state.signOutUI.isVisible,
    repFirstName: state.projectreps.firstName,
    repLastName: state.projectreps.lastName,
    repEmail: state.projectreps.email,
    repPhone: state.projectreps.phoneNumber,
    projectName: state.projectaddress.projectName,
    projectStreet: state.projectaddress.projectStreet,
    projectStreet2: state.projectaddress.projectStreet2,
    projectCity: state.projectaddress.projectCity,
    projectZip: state.projectaddress.projectZip,
    projectState: state.projectaddress.projectState,
    resiToggle: state.tax.resiToggle,
    setToggleView,
});

const mapDispatchToProps = dispatch => ({
    setSignOutIsVisible: isVisible => dispatch(setSignOutIsVisible(isVisible)),
    eraseCustomer: () => dispatch(eraseCustomer()),
    eraseCustomerContact: () => dispatch(eraseCustomerContact()),
    setToggleView: value => dispatch(setToggleView(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);



// WEBPACK FOOTER //
// ./src/containers/NavBar/index.js